// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__PYf9g","inner":"Footer_inner__AjJuI"};